import { render, staticRenderFns } from "./custom-functions-tab.vue?vue&type=template&id=4d35b6c2"
import script from "./custom-functions-tab.vue?vue&type=script&lang=js"
export * from "./custom-functions-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports